import { render } from "./OdontogramDetail.vue?vue&type=template&id=ee386ea0&scoped=true"
import script from "./OdontogramDetail.vue?vue&type=script&lang=js"
export * from "./OdontogramDetail.vue?vue&type=script&lang=js"

import "./OdontogramDetail.vue?vue&type=style&index=0&id=ee386ea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee386ea0"]])

export default __exports__